import { FormItemBase } from './form-item-base';
import { FormItemControlService } from '../services/form-item-control.service';

export class FormItemButton extends FormItemBase<string> {
  controlType = 'button';
  type: boolean;
  widthHint: number;
  actionType: string;
  icon: string;
  alertLevel: string;
  bAlertUser: boolean;
  alertMessage: string;
  formItemControlService: FormItemControlService;
  bWorksheetErrorsExists: boolean;
  bWorksheetWarningsExist: boolean;

  constructor(options: {
    itemType?: string,
    key?: string,
    label?: string,
    altlabel?: string,
    shortlabel?: string,
    comment?: string,
    required?: boolean,
    order?: number,
    controlType?: string,
    depth?: number,
    isVisible?: boolean,
    isEnabled?: boolean,
    isReadOnly?: boolean,
    useAltText?: boolean,
    widthHint?: string,
    weightHint?: string,
    actionType?: string,
    isTooltipDefined?: boolean,
    alertLevel?: string,
    bWorksheetErrorsExist?: boolean,
    bWorksheetWarningsExist?: boolean,
    formItemControlService?: FormItemControlService
    icon?: string
  } = {}) {
    super(options);
    const key = 'type';
    this.isReadOnly = options.isReadOnly;
    this.type = options[key] || '';
    this.labelClass = 'dx-field-label field-label-override form-item-checkbox-label form-item-depth-' + this.depth.toString();

    this.actionType = options.actionType || 'userdefined';
    this.alertLevel = options.alertLevel || '';
    this.bAlertUser = false;
    this.alertMessage = '';
    this.formItemControlService = options.formItemControlService || null;
    this.bWorksheetErrorsExists = options.bWorksheetErrorsExist || false;
    this.bWorksheetWarningsExist = options.bWorksheetWarningsExist || false;

    this.widthHint = 150;
    if (options.widthHint != null) {
      if (options.widthHint  === 'x-small') {
        this.widthHint = 80;
      } else if (options.widthHint === 'smaller') {
        this.widthHint = 120;
      } else if (options.widthHint === 'larger') {
        this.widthHint = 270;
      } else if (options.widthHint === 'x-large') {
        this.widthHint = 420;
      }
    }

    this.icon = '';
    this.alertLevel = options.alertLevel;

    if (this.formItemControlService != null) {
      this.formItemControlService.updateFormItemButton(this, this.bWorksheetErrorsExists, this.bWorksheetWarningsExist);
    }
  }
}
